<script lang="ts">

import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue'

import { useBreakpoint } from '@/composables/useBreakpoint'

import AsyncIcon from '../atoms/AsyncIcon.vue'

export default defineComponent({
  name: 'LockScreen',
  components: { AsyncIcon },
  props: {
    //
  },
  setup () {
    const size = ref({
      width: 0,
      height: 0
    })

    const screen = useBreakpoint()

    const updateSize = () => {
      size.value.width = window.innerWidth
      size.value.height = window.innerHeight
    }

    onMounted(() => {
      window.addEventListener('resize', updateSize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', updateSize)
    })

    const isLandscape = computed(() => size.value.width > size.value.height)
    const shouldDisplay = computed(() => screen.lg || isLandscape.value)

    return {
      shouldDisplay
    }
  }
})
</script>

<template>
  <div
    class="ctn-lock fixed w-full h-full flex-col gap-4 items-center justify-center overflow-hidden"
    :class="shouldDisplay ? 'flex' : 'hidden'"
  >
    <AsyncIcon name="rotate" class="w-fit text-6xl" />
    <span class="body-1 text-white px-8 text-center">Rotate your device to portrait mode for an optimized experience</span>
  </div>
</template>

<style scoped lang="scss">
.ctn-lock {
  z-index: $z-lockscreen;
  background-color: $c-black;
}

</style>
